export const FIR_DETAILS = {
    'FLFI': {
        name: 'LUSAKA', 
        controllingCountryCode: 'ZMB', 
        controllingCountryName: 'Zambia',
        countries: ['ZMB']
    },
    'FSSS': {
        name: 'SEYCHELLES', 
        controllingCountryCode: 'SYC', 
        controllingCountryName: 'Seychelles',
        countries: ['SYC']
    },
    'GVSC': {
        name: 'SAL OCEANIC', 
        controllingCountryCode: 'CPV', 
        controllingCountryName: 'Cabo Verde',
        countries: ['CPV']
    },
    'FCCC': {
        name: 'BRAZZAVILLE', 
        controllingCountryCode: 'COG', 
        controllingCountryName: 'Congo',
        countries: ['COG', 'GAB', 'GNQ', 'CAF', 'CMR']
    },
    'FVHF': {
        name: 'HARARE', 
        controllingCountryCode: 'ZWE', 
        controllingCountryName: 'Zimbabwe',
        countries: ['ZWE']
    },
    'HCSM': {
        name: 'MOGADISHU', 
        controllingCountryCode: 'SOM', 
        controllingCountryName: 'Somalia',
        countries: ['SOM']
    },
    'HBBA': {
        name: 'BUJUMBURA', 
        controllingCountryCode: 'BDI', 
        controllingCountryName: 'Burundi',
        countries: ['BDI']
    },
    'FYWH': {
        name: 'WINDHOEK', 
        controllingCountryCode: 'NAM', 
        controllingCountryName: 'Namibia',
        countries: ['NAM']
    },
    'GLRB': {
        name: 'ROBERTS', 
        controllingCountryCode: 'LBR', 
        controllingCountryName: 'Liberia',
        countries: ['LBR', 'SLE', 'GIN']
    },
    'FWLL': {
        name: 'LILONGWE', 
        controllingCountryCode: 'MWI', 
        controllingCountryName: 'Malawi',
        countries: ['MWI']
    },
    'FIMM': {
        name: 'MAURITIUS', 
        controllingCountryCode: 'MUS', 
        controllingCountryName: 'Mauritius',
        countries: ['MUS']
    },
    'FZZA': {
        name: 'KINSHASA', 
        controllingCountryCode: 'COD', 
        controllingCountryName: 'Democratic Republic of the Congo',
        countries: ['COD']
    },
    'FNAN': {
        name: 'LUANDA', 
        controllingCountryCode: 'AGO', 
        controllingCountryName: 'Angola',
        countries: ['AGO']
    },
    'FMMM': {
        name: 'ANTANANARIVO', 
        controllingCountryCode: 'MDG', 
        controllingCountryName: 'Madagascar',
        countries: ['MDG']
    },
    'DGAC': {
        name: 'ACCRA', 
        controllingCountryCode: 'GHA', 
        controllingCountryName: 'Ghana',
        countries: ['GHA', 'TGO', 'BEN']
    },
    'FQBE': {
        name: 'BEIRA', 
        controllingCountryCode: 'MOZ', 
        controllingCountryName: 'Mozambique',
        countries: ['MOZ']
    },
    'DNKK': {
        name: 'KANO', 
        controllingCountryCode: 'NGA', 
        controllingCountryName: 'Nigeria',
        countries: ['NGA']
    },
    'FACA': {
        name: 'CAPETOWN', 
        controllingCountryCode: 'ZAF', 
        controllingCountryName: 'South Africa',
        countries: ['ZAF']
    },
    'FBGR': {
        name: 'GABORONE', 
        controllingCountryCode: 'BWA', 
        controllingCountryName: 'Botswana',
        countries: ['BWA']
    },
    'FAJA': {
        name: 'JOHANNESBURG', 
        controllingCountryCode: 'ZAF', 
        controllingCountryName: 'South Africa',
        countries: ['ZAF', 'LSO', 'SWZ']
    },
    'DRRR': {
        name: 'NIAMEY', 
        controllingCountryCode: 'NER', 
        controllingCountryName: 'Niger',
        countries: ['NER', 'MLI', 'BFA']
    },
    'HUEC': {
        name: 'ENTEBBE', 
        controllingCountryCode: 'UGA', 
        controllingCountryName: 'Uganda',
        countries: ['UGA']
    },
    'HAAA': {
        name: 'ADDIS ABABA', 
        controllingCountryCode: 'ETH', 
        controllingCountryName: 'Ethiopia',
        countries: ['ETH', 'DJI']
    },
    'FAJO': {
        name: 'JOHANNESBURG OCEANIC', 
        controllingCountryCode: 'ZAF', 
        controllingCountryName: 'South Africa',
        countries: ['ZAF']
    },
    'HKNA': {
        name: 'NAIROBI', 
        controllingCountryCode: 'KEN', 
        controllingCountryName: 'Kenya',
        countries: ['KEN']
    },
    'GOOO': {
        name: 'DAKAR', 
        controllingCountryCode: 'SEN', 
        controllingCountryName: 'Senegal',
        countries: ['SEN', 'MLI', 'MRT', 'CIV', 'GNB']
    },
    'HTDC': {
        name: 'DAR ES SALAAM', 
        controllingCountryCode: 'TZA', 
        controllingCountryName: 'United Republic of Tanzania',
        countries: ['TZA']
    },
    'FTTT': {
        name: 'N DJAMENA', 
        controllingCountryCode: 'TCD', 
        controllingCountryName: 'Chad',
        countries: ['TCD', 'CAF', 'CMR']
    },
    'HRYR': {
        name: 'KIGALI', 
        controllingCountryCode: 'RWA', 
        controllingCountryName: 'Rwanda',
        countries: ['RWA']
    },
    'HHAA': {
        name: 'ASMARA', 
        controllingCountryCode: 'ERI', 
        controllingCountryName: 'Eritrea',
        countries: ['ERI']
    },
    'NFFF': {
        name: 'NADI EAST', 
        controllingCountryCode: 'FJI', 
        controllingCountryName: 'Fiji',
        countries: ['FJI']
    },
    'ZLHW': {
        name: 'LANZHOU', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'NZZO': {
        name: 'AUCKLAND OCEANIC EAST', 
        controllingCountryCode: 'NZL', 
        controllingCountryName: 'New Zealand',
        countries: ['NZL']
    },
    'VYYF': {
        name: 'YANGON', 
        controllingCountryCode: 'MMR', 
        controllingCountryName: 'Myanmar',
        countries: ['MMR']
    },
    'WAAF': {
        name: 'UJUNG PANDANG', 
        controllingCountryCode: 'IDN', 
        controllingCountryName: 'Indonesia',
        countries: ['IDN']
    },
    'WAAZ': {
        name: 'Ujung Pandang ACC', 
        controllingCountryCode: 'IDN', 
        controllingCountryName: 'Indonesia',
        countries: ['IDN']
    },
    'NTTT': {
        name: 'TAHITI', 
        controllingCountryCode: 'PYF', 
        controllingCountryName: 'French Polynesia',
        countries: ['PYF']
    },
    'ZYSH': {
        name: 'SHENYANG', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'ZSHA': {
        name: 'SHANGHAI', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'AYPM': {
        name: 'PORT MORESBY', 
        controllingCountryCode: 'PNG', 
        controllingCountryName: 'Papua New Guinea',
        countries: ['PNG']
    },
    'ZKKP': {
        name: 'PYONGYANG', 
        controllingCountryCode: 'PRK', 
        controllingCountryName: 'Democratic People\'s Republic of Korea',
        countries: ['PRK']
    },
    'VDPF': {
        name: 'PHNOM PENH', 
        controllingCountryCode: 'KHM', 
        controllingCountryName: 'Cambodia',
        countries: ['KHM']
    },
    'VABF': {
        name: 'MUMBAI', 
        controllingCountryCode: 'IND', 
        controllingCountryName: 'India',
        countries: ['IND']
    },
    'VRMF': {
        name: 'MALE', 
        controllingCountryCode: 'MDV', 
        controllingCountryName: 'Maldives',
        countries: ['MDV']
    },
    'YMMM': {
        name: 'MELBOURNE', 
        controllingCountryCode: 'AUS', 
        controllingCountryName: 'Australia',
        countries: ['AUS']
    },
    'ZWUQ': {
        name: 'URUMQI', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'OPKR': {
        name: 'KARACHI', 
        controllingCountryCode: 'PAK', 
        controllingCountryName: 'Pakistan',
        countries: ['PAK']
    },
    'RPHI': {
        name: 'MANILA', 
        controllingCountryCode: 'PHL', 
        controllingCountryName: 'Philippines',
        countries: ['PHL']
    },
    'RKRR': {
        name: 'INCHEON', 
        controllingCountryCode: 'KOR', 
        controllingCountryName: 'Republic of Korea',
        countries: ['KOR']
    },
    'ZPKM': {
        name: 'KUNMING', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'RJJJ': {
        name: 'FUKUOKA', 
        controllingCountryCode: 'JPN', 
        controllingCountryName: 'Japan',
        countries: ['JPN']
    },
    'WMFC': {
        name: 'KUALA LUMPUR', 
        controllingCountryCode: 'MYS', 
        controllingCountryName: 'Malaysia',
        countries: ['MYS']
    },
    'ZHWH': {
        name: 'WUHAN', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'VLVT': {
        name: 'VIENTIANE', 
        controllingCountryCode: 'LAO', 
        controllingCountryName: 'Lao People\'s Democratic Republic',
        countries: ['LAO']
    },
    'ANAU': {
        name: 'NAURU', 
        controllingCountryCode: 'NRU', 
        controllingCountryName: 'Nauru',
        countries: ['NRU']
    },
    'RCAA': {
        name: 'TAIPEI', 
        controllingCountryCode: 'TWN', 
        controllingCountryName: 'Taiwan',
        countries: ['TWN']
    },
    'VVVV': {
        name: 'HANOI', 
        controllingCountryCode: 'VNM', 
        controllingCountryName: 'Viet Nam',
        countries: ['VNM']
    },
    'WBFC': {
        name: 'KOTA KINABALU', 
        controllingCountryCode: 'BRN', 
        controllingCountryName: 'Brunei Darussalam',
        countries: ['BRN']
    },
    'OPLR': {
        name: 'LAHORE', 
        controllingCountryCode: 'PAK', 
        controllingCountryName: 'Pakistan',
        countries: ['PAK']
    },
    'VECF': {
        name: 'KOLKATA', 
        controllingCountryCode: 'IND', 
        controllingCountryName: 'India',
        countries: ['IND']
    },
    'VNSM': {
        name: 'KATHMANDU', 
        controllingCountryCode: 'NPL', 
        controllingCountryName: 'Nepal',
        countries: ['NPL']
    },
    'ZGZU': {
        name: 'GUANGZHOU', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'ZBPE': {
        name: 'BEIJING', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'VTBB': {
        name: 'BANGKOK', 
        controllingCountryCode: 'THA', 
        controllingCountryName: 'Thailand',
        countries: ['THA']
    },
    'WIIF': {
        name: 'JAKARTA', 
        controllingCountryCode: 'IDN', 
        controllingCountryName: 'Indonesia',
        countries: ['IDN']
    },
    'WSJC': {
        name: 'SINGAPORE', 
        controllingCountryCode: 'SGP', 
        controllingCountryName: 'Singapore',
        countries: ['SGP']
    },
    'AGGG': {
        name: 'HONIARA', 
        controllingCountryCode: 'SLB', 
        controllingCountryName: 'Solomon Islands',
        countries: ['SLB']
    },
    'VIDF': {
        name: 'DELHI', 
        controllingCountryCode: 'IND', 
        controllingCountryName: 'India',
        countries: ['IND']
    },
    'VVTS': {
        name: 'HO-CHI-MINH', 
        controllingCountryCode: 'VNM', 
        controllingCountryName: 'Viet Nam',
        countries: ['VNM']
    },
    'ZJSA': {
        name: 'SANYA', 
        controllingCountryCode: 'CHN', 
        controllingCountryName: 'China',
        countries: ['CHN']
    },
    'VHHK': {
        name: 'HONG KONG', 
        controllingCountryCode: 'HKG', 
        controllingCountryName: 'China, Hong Kong Special Administrative Region',
        countries: ['HKG']
    },
    'NZZC': {
        name: 'NEW ZEALAND', 
        controllingCountryCode: 'NZL', 
        controllingCountryName: 'New Zealand',
        countries: ['NZL']
    },
    'ZMUB': {
        name: 'ULAN BATOR', 
        controllingCountryCode: 'MNG', 
        controllingCountryName: 'Mongolia',
        countries: ['MNG']
    },
    'VGFR': {
        name: 'DHAKA', 
        controllingCountryCode: 'BGD', 
        controllingCountryName: 'Bangladesh',
        countries: ['BGD']
    },
    'KZAK': {
        name: 'OAKLAND OCEANIC EAST', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'YBBB': {
        name: 'BRISBANE', 
        controllingCountryCode: 'AUS', 
        controllingCountryName: 'Australia',
        countries: ['AUS']
    },
    'VCCF': {
        name: 'COLOMBO', 
        controllingCountryCode: 'LKA', 
        controllingCountryName: 'Sri Lanka',
        countries: ['LKA']
    },
    'OAKX': {
        name: 'KABUL', 
        controllingCountryCode: 'AFG', 
        controllingCountryName: 'Afghanistan',
        countries: ['AFG']
    },
    'VOMF': {
        name: 'CHENNAI', 
        controllingCountryCode: 'IND', 
        controllingCountryName: 'India',
        countries: ['IND']
    },
    'KZWY': {
        name: 'NEW YORK OCEANIC WEST', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'MMFR': {
        name: 'MEXICO', 
        controllingCountryCode: 'MEX', 
        controllingCountryName: 'Mexico',
        countries: ['MEX']
    },
    'MDCS': {
        name: 'SANTO DOMINGO', 
        controllingCountryCode: 'DOM', 
        controllingCountryName: 'Dominican Republic',
        countries: ['DOM']
    },
    'TNCF': {
        name: 'CURACAO', 
        controllingCountryCode: 'ABW', 
        controllingCountryName: 'Aruba',
        countries: ['ABW']
    },
    'MTEG': {
        name: 'PORT AU PRINCE', 
        controllingCountryCode: 'HTI', 
        controllingCountryName: 'Haiti',
        countries: ['HTI']
    },
    'MYNA': {
        name: 'NASSAU', 
        controllingCountryCode: 'BHS', 
        controllingCountryName: 'Bahamas',
        countries: ['BHS']
    },
    'TJZS': {
        name: 'SAN JUAN', 
        controllingCountryCode: 'PRI', 
        controllingCountryName: 'Puerto Rico',
        countries: ['PRI']
    },
    'MMFO': {
        name: 'MAZATLAN OCEANIC', 
        controllingCountryCode: 'MEX', 
        controllingCountryName: 'Mexico',
        countries: ['MEX']
    },
    'MKJK': {
        name: 'KINGSTON', 
        controllingCountryCode: 'JAM', 
        controllingCountryName: 'Jamaica',
        countries: ['JAM']
    },
    'MUFH': {
        name: 'HABANA', 
        controllingCountryCode: 'CUB', 
        controllingCountryName: 'Cuba',
        countries: ['CUB']
    },
    'MHTG': {
        name: 'CENTRAL AMERICAN', 
        controllingCountryCode: 'HND', 
        controllingCountryName: 'Honduras',
        countries: ['HND', 'BLZ', 'GTM', 'SLV', 'NIC', 'CRI']
    },
    'UWKD': {
        name: 'KAZAN', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UEEE': {
        name: 'YAKUTSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UEMO': {
        name: 'OLEKMINSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UUYY': {
        name: 'SYKTYVKAR', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'USTV': {
        name: 'TYUMEN ROSCHINO', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'ULAM': {
        name: 'NARYAN-MAR', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UAII': {
        name: 'NUR SULTAN"', 
        controllingCountryCode: 'KAZ', 
        controllingCountryName: 'Kazakhstan',
        countries: ['KAZ']
    },
    'UACN': {
        name: 'SHYMKENT', 
        controllingCountryCode: 'KAZ', 
        controllingCountryName: 'Kazakhstan',
        countries: ['KAZ']
    },
    'ULKK': {
        name: 'KOTLAS', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'ULAA': {
        name: 'ARKHANGELSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'USSS': {
        name: 'YEKATERINBURG', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'USCC': {
        name: 'CHELYABINSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UKFV': {
        name: 'SIMFEROPOL', 
        controllingCountryCode: 'UKR', 
        controllingCountryName: 'Ukraine',
        countries: ['UKR']
    },
    'LYBA': {
        name: 'BEOGRAD', 
        controllingCountryCode: 'SRB', 
        controllingCountryName: 'Serbia',
        countries: ['SRB', 'MNE']
    },
    'UKBV': {
        name: 'KYIV', 
        controllingCountryCode: 'UKR', 
        controllingCountryName: 'Ukraine',
        countries: ['UKR']
    },
    'LDZO': {
        name: 'ZAGREB', 
        controllingCountryCode: 'HRV', 
        controllingCountryName: 'Croatia',
        countries: ['HRV']
    },
    'LAAA': {
        name: 'TIRANA', 
        controllingCountryCode: 'ALB', 
        controllingCountryName: 'Albania',
        countries: ['ALB']
    },
    'UERR': {
        name: 'MIRNY', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UZTR': {
        name: 'TASHKENT', 
        controllingCountryCode: 'UZB', 
        controllingCountryName: 'Uzbekistan',
        countries: ['UZB']
    },
    'LQSB': {
        name: 'SARAJEVO', 
        controllingCountryCode: 'BIH', 
        controllingCountryName: 'Bosnia and Herzegovina',
        countries: ['BIH']
    },
    'EETT': {
        name: 'TALLINN', 
        controllingCountryCode: 'EST', 
        controllingCountryName: 'Estonia',
        countries: ['EST']
    },
    'UTAT': {
        name: 'DASHOGUZ', 
        controllingCountryCode: 'TKM', 
        controllingCountryName: 'Turkmenistan',
        countries: ['TKM']
    },
    'LSAS': {
        name: 'SWITZERLAND', 
        controllingCountryCode: 'CHE', 
        controllingCountryName: 'Switzerland',
        countries: ['CHE']
    },
    'UDDD': {
        name: 'YEREVAN ZVARTNOTS', 
        controllingCountryCode: 'ARM', 
        controllingCountryName: 'Armenia',
        countries: ['ARM']
    },
    'LBSR': {
        name: 'SOFIA', 
        controllingCountryCode: 'BGR', 
        controllingCountryName: 'Bulgaria',
        countries: ['BGR']
    },
    'ESAA': {
        name: 'SWEDEN', 
        controllingCountryCode: 'SWE', 
        controllingCountryName: 'Sweden',
        countries: ['SWE']
    },
    'UAAA': {
        name: 'ALMATY', 
        controllingCountryCode: 'KAZ', 
        controllingCountryName: 'Kazakhstan',
        countries: ['KAZ']
    },
    'EGPX': {
        name: 'SCOTTISH', 
        controllingCountryCode: 'GBR', 
        controllingCountryName: 'United Kingdom of Great Britain and Northern Ireland',
        countries: ['GBR']
    },
    'UWWW': {
        name: 'SAMARA', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'URRV': {
        name: 'ROSTOV-NA-DONU', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'LIRR': {
        name: 'ROMA', 
        controllingCountryCode: 'ITA', 
        controllingCountryName: 'Italy',
        countries: ['ITA']
    },
    'LKAA': {
        name: 'PRAHA', 
        controllingCountryCode: 'CZE', 
        controllingCountryName: 'Czech Republic',
        countries: ['CZE']
    },
    'LLLL': {
        name: 'TEL-AVIV ACC', 
        controllingCountryCode: 'ISR', 
        controllingCountryName: 'Israel',
        countries: ['ISR']
    },
    'UTAK': {
        name: 'TURKMENBASHI', 
        controllingCountryCode: 'TKM', 
        controllingCountryName: 'Turkmenistan',
        countries: ['TKM']
    },
    'USTR': {
        name: 'TYUMEN ROSCHINO', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'USDD': {
        name: 'SALEKHARD', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'LHCC': {
        name: 'BUDAPEST', 
        controllingCountryCode: 'HUN', 
        controllingCountryName: 'Hungary',
        countries: ['HUN']
    },
    'ULWW': {
        name: 'VOLOGDA', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'EDGG': {
        name: 'LANGEN', 
        controllingCountryCode: 'DEU', 
        controllingCountryName: 'Germany',
        countries: ['DEU']
    },
    'UCFO': {
        name: 'OSH', 
        controllingCountryCode: 'KGZ', 
        controllingCountryName: 'Kyrgyzstan',
        countries: ['KGZ']
    },
    'EYVL': {
        name: 'VILNIUS', 
        controllingCountryCode: 'LTU', 
        controllingCountryName: 'Lithuania',
        countries: ['LTU']
    },
    'DAAA': {
        name: 'ALGER', 
        controllingCountryCode: 'DZA', 
        controllingCountryName: 'Algeria',
        countries: ['DZA']
    },
    'LZBB': {
        name: 'BRATISLAVA', 
        controllingCountryCode: 'SVK', 
        controllingCountryName: 'Slovakia',
        countries: ['SVK']
    },
    'EHAA': {
        name: 'AMSTERDAM', 
        controllingCountryCode: 'NLD', 
        controllingCountryName: 'Netherlands',
        countries: ['NLD']
    },
    'UNNT': {
        name: 'NOVOSIBIRSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UIII': {
        name: 'IRKUTSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UERP': {
        name: 'POLIARNY', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'EBBU': {
        name: 'BRUXELLES', 
        controllingCountryCode: 'BEL', 
        controllingCountryName: 'Belgium',
        countries: ['BEL']
    },
    'UTNR': {
        name: 'NUKUS', 
        controllingCountryCode: 'UZB', 
        controllingCountryName: 'Uzbekistan',
        countries: ['UZB']
    },
    'UELL': {
        name: 'CHULMAN', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'LECB': {
        name: 'BARCELONA', 
        controllingCountryCode: 'ESP', 
        controllingCountryName: 'Spain',
        countries: ['ESP']
    },
    'USPP': {
        name: 'PERM', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UMMV': {
        name: 'MINSK', 
        controllingCountryCode: 'BLR', 
        controllingCountryName: 'Belarus',
        countries: ['BLR']
    },
    'LCCC': {
        name: 'NICOSIA', 
        controllingCountryCode: 'CYP', 
        controllingCountryName: 'Cyprus',
        countries: ['CYP']
    },
    'LIMM': {
        name: 'MILANO', 
        controllingCountryCode: 'ITA', 
        controllingCountryName: 'Italy',
        countries: ['ITA']
    },
    'EPWW': {
        name: 'WARSZAWA', 
        controllingCountryCode: 'POL', 
        controllingCountryName: 'Poland',
        countries: ['POL']
    },
    'EDMM': {
        name: 'MUNICH', 
        controllingCountryCode: 'DEU', 
        controllingCountryName: 'Germany',
        countries: ['DEU']
    },
    'LJLA': {
        name: 'LJUBLJANA', 
        controllingCountryCode: 'SVN', 
        controllingCountryName: 'Slovenia',
        countries: ['SVN']
    },
    'USCM': {
        name: 'MAGNITOGORSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'LPPC': {
        name: 'LISBOA', 
        controllingCountryCode: 'PRT', 
        controllingCountryName: 'Portugal',
        countries: ['PRT']
    },
    'LTBB': {
        name: 'ISTANBUL', 
        controllingCountryCode: 'TUR', 
        controllingCountryName: 'Turkey',
        countries: ['TUR']
    },
    'USKK': {
        name: 'KIROV', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'LFEE': {
        name: 'REIMS', 
        controllingCountryCode: 'FRA', 
        controllingCountryName: 'France',
        countries: ['FRA']
    },
    'UKLV': {
        name: 'L VIV', 
        controllingCountryCode: 'UKR', 
        controllingCountryName: 'Ukraine',
        countries: ['UKR']
    },
    'UMKK': {
        name: 'KALININGRAD', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'EKDK': {
        name: 'KOBENHAVN', 
        controllingCountryCode: 'DNK', 
        controllingCountryName: 'Denmark',
        countries: ['DNK']
    },
    'UGGG': {
        name: 'TBILISI', 
        controllingCountryCode: 'GEO', 
        controllingCountryName: 'Georgia',
        countries: ['GEO']
    },
    'UHHH': {
        name: 'KHABAROVSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'LECM': {
        name: 'MADRID', 
        controllingCountryCode: 'ESP', 
        controllingCountryName: 'Spain',
        countries: ['ESP']
    },
    'LFMM': {
        name: 'MARSEILLE', 
        controllingCountryCode: 'FRA', 
        controllingCountryName: 'France',
        countries: ['FRA']
    },
    'LGGG': {
        name: 'ATHINAI', 
        controllingCountryCode: 'GRC', 
        controllingCountryName: 'Greece',
        countries: ['GRC']
    },
    'UNKL': {
        name: 'KRASNOYARSK', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UHPP': {
        name: 'MAGADAN WEST', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UZSD': {
        name: 'SAMARKAND', 
        controllingCountryCode: 'UZB', 
        controllingCountryName: 'Uzbekistan',
        countries: ['UZB']
    },
    'UUWV': {
        name: 'MOSCOW', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'DTTC': {
        name: 'TUNIS', 
        controllingCountryCode: 'TUN', 
        controllingCountryName: 'Tunisia',
        countries: ['TUN']
    },
    'EDWW': {
        name: 'BREMEN', 
        controllingCountryCode: 'DEU', 
        controllingCountryName: 'Germany',
        countries: ['DEU']
    },
    'UTDD': {
        name: 'DUSHANBE', 
        controllingCountryCode: 'TJK', 
        controllingCountryName: 'Tajikistan',
        countries: ['TJK']
    },
    'EGTT': {
        name: 'LONDON', 
        controllingCountryCode: 'GBR', 
        controllingCountryName: 'United Kingdom of Great Britain and Northern Ireland',
        countries: ['GBR']
    },
    'LTAA': {
        name: 'ANKARA', 
        controllingCountryCode: 'TUR', 
        controllingCountryName: 'Turkey',
        countries: ['TUR']
    },
    'ULMM': {
        name: 'MURMANSK OCEANIC EAST', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UBBA': {
        name: 'BAKU', 
        controllingCountryCode: 'AZE', 
        controllingCountryName: 'Azerbaijan',
        countries: ['AZE']
    },
    'LFFF': {
        name: 'PARIS', 
        controllingCountryCode: 'FRA', 
        controllingCountryName: 'France',
        countries: ['FRA']
    },
    'UCFM': {
        name: 'BISHKEK', 
        controllingCountryCode: 'KGZ', 
        controllingCountryName: 'Kyrgyzstan',
        countries: ['KGZ']
    },
    'EFIN': {
        name: 'FINLAND', 
        controllingCountryCode: 'FIN', 
        controllingCountryName: 'Finland',
        countries: ['FIN']
    },
    'GMMM': {
        name: 'CASABLANCA', 
        controllingCountryCode: 'MAR', 
        controllingCountryName: 'Morocco',
        countries: ['MAR']
    },
    'LUUU': {
        name: 'CHISINAU', 
        controllingCountryCode: 'MDA', 
        controllingCountryName: 'Republic of Moldova',
        countries: ['MDA']
    },
    'UKOV': {
        name: 'ODESA', 
        controllingCountryCode: 'UKR', 
        controllingCountryName: 'Ukraine',
        countries: ['UKR']
    },
    'LMMM': {
        name: 'MALTA', 
        controllingCountryCode: 'MLT', 
        controllingCountryName: 'Malta',
        countries: ['MLT']
    },
    'LOVV': {
        name: 'WIEN', 
        controllingCountryCode: 'AUT', 
        controllingCountryName: 'Austria',
        countries: ['AUT']
    },
    'ENOR': {
        name: 'NORWAY', 
        controllingCountryCode: 'NOR', 
        controllingCountryName: 'Norway',
        countries: ['NOR']
    },
    'UACC': {
        name: 'ASTANA', 
        controllingCountryCode: 'KAZ', 
        controllingCountryName: 'Kazakhstan',
        countries: ['KAZ']
    },
    'LWSS': {
        name: 'SKOPJE', 
        controllingCountryCode: 'MKD', 
        controllingCountryName: 'The Republic of North Macedonia',
        countries: ['MKD']
    },
    'LRBB': {
        name: 'BUCURESTI', 
        controllingCountryCode: 'ROU', 
        controllingCountryName: 'Romania',
        countries: ['ROU']
    },
    'GCCC': {
        name: 'CANARIAS', 
        controllingCountryCode: 'ESP', 
        controllingCountryName: 'Spain',
        countries: ['ESP']
    },
    'LFRR': {
        name: 'BREST', 
        controllingCountryCode: 'FRA', 
        controllingCountryName: 'France',
        countries: ['FRA']
    },
    'EISN': {
        name: 'SHANNON', 
        controllingCountryCode: 'IRL', 
        controllingCountryName: 'Ireland',
        countries: ['IRL']
    },
    'LFBB': {
        name: 'BORDEAUX', 
        controllingCountryCode: 'FRA', 
        controllingCountryName: 'France',
        countries: ['FRA']
    },
    'USDS': {
        name: 'TARKO-SALE', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'LIBB': {
        name: 'BRINDISI', 
        controllingCountryCode: 'ITA', 
        controllingCountryName: 'Italy',
        countries: ['ITA']
    },
    'UATT': {
        name: 'AKTAU', 
        controllingCountryCode: 'KAZ', 
        controllingCountryName: 'Kazakhstan',
        countries: ['KAZ']
    },
    'USDK': {
        name: 'KAMENNY', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UTAA': {
        name: 'ASHGABAT', 
        controllingCountryCode: 'TKM', 
        controllingCountryName: 'Turkmenistan',
        countries: ['TKM']
    },
    'UTAV': {
        name: 'TURKMENABAT', 
        controllingCountryCode: 'TKM', 
        controllingCountryName: 'Turkmenistan',
        countries: ['TKM']
    },
    'UKDV': {
        name: 'DNIPROPETROVS\'K', 
        controllingCountryCode: 'UKR', 
        controllingCountryName: 'Ukraine',
        countries: ['UKR']
    },
    'EVRR': {
        name: 'RIGA', 
        controllingCountryCode: 'LVA', 
        controllingCountryName: 'Latvia',
        countries: ['LVA']
    },
    'ULLL': {
        name: 'SANKT-PETERBURG', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'UHMM': {
        name: 'MAGADAN OCEANIC EAST', 
        controllingCountryCode: 'RUS', 
        controllingCountryName: 'Russian Federation',
        countries: ['RUS']
    },
    'OKAC': {
        name: 'KUWAIT', 
        controllingCountryCode: 'KWT', 
        controllingCountryName: 'Kuwait',
        countries: ['KWT']
    },
    'OJAC': {
        name: 'AMMAN', 
        controllingCountryCode: 'JOR', 
        controllingCountryName: 'Jordan',
        countries: ['JOR']
    },
    'OBBB': {
        name: 'BAHRAIN', 
        controllingCountryCode: 'BHR', 
        controllingCountryName: 'Bahrain',
        countries: ['BHR']
    },
    'HLLL': {
        name: 'TRIPOLI', 
        controllingCountryCode: 'LBY', 
        controllingCountryName: 'Libya',
        countries: ['LBY']
    },
    'OIIX': {
        name: 'TEHRAN', 
        controllingCountryCode: 'IRN', 
        controllingCountryName: 'Iran (Islamic Republic of)',
        countries: ['IRN']
    },
    'HSSS': {
        name: 'KHARTOUM', 
        controllingCountryCode: 'SDN', 
        controllingCountryName: 'Sudan',
        countries: ['SDN', 'SSD']
    },
    'OYSC': {
        name: 'SANA A', 
        controllingCountryCode: 'YEM', 
        controllingCountryName: 'Yemen',
        countries: ['YEM']
    },
    'OOMM': {
        name: 'MUSCAT', 
        controllingCountryCode: 'OMN', 
        controllingCountryName: 'Oman',
        countries: ['OMN']
    },
    'OMAE': {
        name: 'EMIRATES', 
        controllingCountryCode: 'ARE', 
        controllingCountryName: 'United Arab Emirates',
        countries: ['ARE']
    },
    'OSTT': {
        name: 'DAMASCUS', 
        controllingCountryCode: 'SYR', 
        controllingCountryName: 'Syrian Arab Republic',
        countries: ['SYR']
    },
    'HECC': {
        name: 'CAIRO', 
        controllingCountryCode: 'EGY', 
        controllingCountryName: 'Egypt',
        countries: ['EGY']
    },
    'OEJD': {
        name: 'JEDDAH', 
        controllingCountryCode: 'SAU', 
        controllingCountryName: 'Saudi Arabia',
        countries: ['SAU']
    },
    'OLBB': {
        name: 'BEIRUT', 
        controllingCountryCode: 'LBN', 
        controllingCountryName: 'Lebanon',
        countries: ['LBN']
    },
    'ORBB': {
        name: 'BAGHDAD', 
        controllingCountryCode: 'IRQ', 
        controllingCountryName: 'Iraq',
        countries: ['IRQ']
    },
    'KZDC': {
        name: 'WASHINGTON', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZAU': {
        name: 'CHICAGO', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'CZWG': {
        name: 'WINNIPEG', 
        controllingCountryCode: 'CAN', 
        controllingCountryName: 'Canada',
        countries: ['CAN']
    },
    'CZYZ': {
        name: 'TORONTO', 
        controllingCountryCode: 'CAN', 
        controllingCountryName: 'Canada',
        countries: ['CAN']
    },
    'KZSE': {
        name: 'SEATTLE', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZHU': {
        name: 'HOUSTON', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'PAZA': {
        name: 'ANCHORAGE ARCTIC', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZLC': {
        name: 'SALT LAKE', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZOA': {
        name: 'OAKLAND', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'CZUL': {
        name: 'MONTREAL', 
        controllingCountryCode: 'CAN', 
        controllingCountryName: 'Canada',
        countries: ['CAN']
    },
    'CZQM': {
        name: 'MONCTON', 
        controllingCountryCode: 'CAN', 
        controllingCountryName: 'Canada',
        countries: ['CAN']
    },
    'CZEG': {
        name: 'EDMONTON', 
        controllingCountryCode: 'CAN', 
        controllingCountryName: 'Canada',
        countries: ['CAN']
    },
    'KZLA': {
        name: 'LOS ANGELES', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZBW': {
        name: 'BOSTON', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZID': {
        name: 'INDIANAPOLIS', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZNY': {
        name: 'NEW YORK', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZME': {
        name: 'MEMPHIS', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZJX': {
        name: 'JACKSONVILLE', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZOB': {
        name: 'CLEVELAND', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZKC': {
        name: 'KANSAS CITY', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZAB': {
        name: 'ALBUQUERQUE', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'CZVR': {
        name: 'VANCOUVER', 
        controllingCountryCode: 'CAN', 
        controllingCountryName: 'Canada',
        countries: ['CAN']
    },
    'KZFW': {
        name: 'FT WORTH', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZMA': {
        name: 'MIAMI', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZMP': {
        name: 'MINNEAPOLIS', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZDV': {
        name: 'DENVER', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'KZTL': {
        name: 'ATLANTA', 
        controllingCountryCode: 'USA', 
        controllingCountryName: 'United States of America',
        countries: ['USA']
    },
    'EGGX': {
        name: 'SHANWICK OCEANIC', 
        controllingCountryCode: 'GBR', 
        controllingCountryName: 'United Kingdom of Great Britain and Northern Ireland',
        countries: ['GBR']
    },
    'LPPO': {
        name: 'SANTA MARIA OCEANIC', 
        controllingCountryCode: 'PRT', 
        controllingCountryName: 'Portugal',
        countries: ['PRT']
    },
    'CZQX': {
        name: 'GANDER OCEANIC', 
        controllingCountryCode: 'CAN', 
        controllingCountryName: 'Canada',
        countries: ['CAN']
    },
    'BIRD': {
        name: 'REYKJAVIK', 
        controllingCountryCode: 'ISL', 
        controllingCountryName: 'Iceland',
        countries: ['ISL']
    },
    'ENOB': {
        name: 'BODO OCEANIC', 
        controllingCountryCode: 'NOR', 
        controllingCountryName: 'Norway',
        countries: ['NOR']
    },
    'BGGL': {
        name: 'SONDRESTROM', 
        controllingCountryCode: 'GRL', 
        controllingCountryName: 'Greenland',
        countries: ['GRL']
    },
    'SPIM': {
        name: 'LIMA', 
        controllingCountryCode: 'PER', 
        controllingCountryName: 'Peru',
        countries: ['PER']
    },
    'SBAO': {
        name: 'ATLANTICO', 
        controllingCountryCode: 'BRA', 
        controllingCountryName: 'Brazil',
        countries: ['BRA']
    },
    'SBAZ': {
        name: 'AMAZONICA', 
        controllingCountryCode: 'BRA', 
        controllingCountryName: 'Brazil',
        countries: ['BRA']
    },
    'SBCW': {
        name: 'CURITIBA', 
        controllingCountryCode: 'BRA', 
        controllingCountryName: 'Brazil',
        countries: ['BRA']
    },
    'SOOO': {
        name: 'CAYENNE', 
        controllingCountryCode: 'GUF', 
        controllingCountryName: 'French Guiana',
        countries: ['GUF']
    },
    'SARR': {
        name: 'RESISTENCIA', 
        controllingCountryCode: 'ARG', 
        controllingCountryName: 'Argentina',
        countries: ['ARG']
    },
    'SCTZ': {
        name: 'PUERTO MONTT', 
        controllingCountryCode: 'CHL', 
        controllingCountryName: 'Chile',
        countries: ['CHL']
    },
    'MPZL': {
        name: 'PANAMA', 
        controllingCountryCode: 'PAN', 
        controllingCountryName: 'Panama',
        countries: ['PAN']
    },
    'TTZP': {
        name: 'PIARCO', 
        controllingCountryCode: 'TTO', 
        controllingCountryName: 'Trinidad and Tobago',
        countries: ['TTO']
    },
    'SAEF': {
        name: 'EZEIZA', 
        controllingCountryCode: 'ARG', 
        controllingCountryName: 'Argentina',
        countries: ['ARG']
    },
    'SAMF': {
        name: 'MENDOZA', 
        controllingCountryCode: 'ARG', 
        controllingCountryName: 'Argentina',
        countries: ['ARG']
    },
    'SVZM': {
        name: 'MAIQUETIA', 
        controllingCountryCode: 'VEN', 
        controllingCountryName: 'Venezuela (Bolivarian Republic of)',
        countries: ['VEN']
    },
    'SCFZ': {
        name: 'ANTOFAGASTA', 
        controllingCountryCode: 'CHL', 
        controllingCountryName: 'Chile',
        countries: ['CHL']
    },
    'SEFG': {
        name: 'GUAYAQUIL', 
        controllingCountryCode: 'ECU', 
        controllingCountryName: 'Ecuador',
        countries: ['ECU']
    },
    'SCCZ': {
        name: 'PUNTA ARENAS', 
        controllingCountryCode: 'CHL', 
        controllingCountryName: 'Chile',
        countries: ['CHL']
    },
    'SKED': {
        name: 'BOGOTA', 
        controllingCountryCode: 'COL', 
        controllingCountryName: 'Colombia',
        countries: ['COL']
    },
    'SYGC': {
        name: 'GEORGETOWN', 
        controllingCountryCode: 'GUY', 
        controllingCountryName: 'Guyana',
        countries: ['GUY']
    },
    'SMPM': {
        name: 'PARAMARIBO', 
        controllingCountryCode: 'SUR', 
        controllingCountryName: 'Suriname',
        countries: ['SUR']
    },
    'SUEO': {
        name: 'MONTEVIDEO', 
        controllingCountryCode: 'URY', 
        controllingCountryName: 'Uruguay',
        countries: ['URY']
    },
    'SAVF': {
        name: 'COMODORO RIVADAVIA', 
        controllingCountryCode: 'ARG', 
        controllingCountryName: 'Argentina',
        countries: ['ARG']
    },
    'SCEZ': {
        name: 'SANTIAGO', 
        controllingCountryCode: 'CHL', 
        controllingCountryName: 'Chile',
        countries: ['CHL']
    },
    'SLLF': {
        name: 'LA PAZ', 
        controllingCountryCode: 'BOL', 
        controllingCountryName: 'Bolivia (Plurinational State of)',
        countries: ['BOL']
    },
    'SGFA': {
        name: 'ASUNCION', 
        controllingCountryCode: 'PRY', 
        controllingCountryName: 'Paraguay',
        countries: ['PRY']
    },
    'SACF': {
        name: 'CORDOBA', 
        controllingCountryCode: 'ARG', 
        controllingCountryName: 'Argentina',
        countries: ['ARG']
    },
    'SBRE': {
        name: 'RECIFE', 
        controllingCountryCode: 'BRA', 
        controllingCountryName: 'Brazil',
        countries: ['BRA']
    },
    'SCIZ': {
        name: 'ISLA DE PASCUA', 
        controllingCountryCode: 'CHL', 
        controllingCountryName: 'Chile',
        countries: ['CHL']
    },
    'SBBS': {
        name: 'BRASILIA', 
        controllingCountryCode: 'BRA', 
        controllingCountryName: 'Brazil',
        countries: ['BRA']
    },
    'SKEC': {
        name: 'BARRANQUILLA', 
        controllingCountryCode: 'COL', 
        controllingCountryName: 'Colombia',
        countries: ['COL']
    }
}